export const it = {
  reports: {
    pageTitle: 'Reports',
    export: 'Esporta',
    tabs: {
      softSkills: 'Soft Skills',
      hardSkills: 'Hard Skills',
    },
    assessments: {
      pageTitle: 'Risultati Assessment',
      table: {
        firstName: 'Nome',
        lastName: 'Cognome',
        role: 'Ruolo',
        department: 'Dipartimento',
        team: 'Team',
        completionStatus: 'Stato assessment',
        completionStatusOptions: {
          sent: 'Inviato il {{timestamp}}',
          finished: 'Completato il {{timestamp}}',
        },
      },
      tutorial: {
        title: 'Consulta la reportistica',
        slides: {
          slide1: {
            title: 'Risultati Assessment',
            description:
              'Qui trovi la tabella con i dati dell’ultimo assessment compilato per ogni dipendente. La sezione è divisa in due tab: Soft Skills e Hard Skills, per analizzare le competenze per tipologia.',
          },
          slide2: {
            title: 'Filtra i dati',
            description:
              'Usa i filtri per segmentare la tabella per Dipartimento, Team, Ruolo e Stato di completamento. Puoi anche filtrare per range di punteggio su ogni singola skill.',
          },
          slide3: {
            title: 'Esporta i risultati',
            description:
              'Clicca su Esporta per scaricare in Excel i dati dell’ultimo assessment. Il file Excel è suddiviso in due fogli: Soft Skills e Hard Skills. Ogni foglio contiene una riga per dipendente con Nome, Cognome, Ruolo, Dipartimento, Team e i punteggi per ogni competenza.',
          },
        },
      },
    },
    trainings: {
      pageTitle: 'Fruizione Training',
      table: {
        firstName: 'Nome',
        lastName: 'Cognome',
        role: 'Ruolo',
        department: 'Dipartimento',
        team: 'Team',
        trainingTime: 'Ore di formazione',
        trainingTimeTooltip:
          'Il calcolo delle ore di formazione comprende il tempo di fruizione sia dei contenuti completati che di quelli in fase di completamento',
        completedContents: 'Contenuti completati',
        contentsInProgress: 'Contenuti in completamento',
      },
      alertBadge:
        'Nell’analisi sono stati presi in considerazione i dati di fruizione di letture, video e quiz hard e soft skills ottenuti negli ultimi 12 mesi',
      exportBadge:
        'Nel file esportabile troverai maggiori dettagli sui dati di fruizione di ogni singolo contenuto di training',
      tutorial: {
        title: 'Consulta la reportistica',
        slides: {
          slide1: {
            title: 'Fruizione training',
            description:
              'Qui trovi la tabella con i dati di fruizione dei contenuti di training hard e soft skills per dipendente, calcolati negli ultimi 12 mesi.',
          },
          slide2: {
            title: 'Filtra i dati',
            description:
              'Usa i filtri per segmentare la tabella per Dipartimento, Team, Ruolo. Puoi anche filtrare per ore di formazione fruite, quantità di corsi completati e in completamento',
          },
          slide3: {
            title: 'Esporta i risultati',
            description:
              'Il file Excel è suddiviso in due fogli: Overview dipendente  - Dettaglio contenuti. I fogli Overview riportano Nome, Cognome, Ruolo, Dipartimento, Team, Ore di formazione, Corsi completati e Corsi in completamento per ogni dipendente. Il foglio di dettaglio dei contenuti riporta i dati di fruizione per ogni contenuto di training.',
          },
        },
      },
    },
  },
};
